export default __webpack_public_path__ + "static/media/puff.6b477021.svg";